import React, { useState } from "react";
import { Modal } from '@themesberg/react-bootstrap';
import { Button, Form, Input, Select, Upload } from "antd";
import { InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { createAboutModal, aboutRefresh, editAboutModal, editABoutVal, aboutEditor, aboutEditorDesc } from "../../../states/about";
import { settingAlert, settingResponse } from "../../../states/settings";
import { dummyRequest, getHtml, getRawData } from "../../../services/utilities";
import { createAbout, updateAbout } from "../../../services/apiCalls";
import { Editor } from "react-draft-wysiwyg";

const AboutModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(aboutRefresh)
  const [showModal, setShowModal] = useRecoilState(createAboutModal);
  const [uploadImage, setUploadImage] = useState(false)
  const [editor, setEditor] = useState('');
  const [editorDesc, setEditorDesc] = useState('')
  const [file, setFile] = useState({})
  const [form] = Form.useForm()

  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  console.log(editor)
  // console.log(editorDesc)
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('content', getHtml(editorDesc))
    // fd.append('title', val.title)
    // fd.append('content', val.content)
    fd.append('type', val.type)
    fd.append('about_image', file);
    const res = await createAbout(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      setFile("")
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Create New Feature</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>          
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={(v) => { if (v === "other") { setUploadImage(false) } else { setUploadImage(true) } }}>
              <Select.Option key='1' value="team">Terms</Select.Option>
              <Select.Option key='2' value="other">Other</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description" name="content" rules={[{ required: true }]}>
            {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 100,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item label="Postion" name="position">
            <Input type='number' />
          </Form.Item>
          {/* {uploadImage &&  */}
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <Button icon={<InboxOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>
          {/* } */}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Create
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
export default AboutModal

export const EditModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(aboutRefresh)
  const value = useRecoilValue(editABoutVal)
  const [showModal, setShowModal] = useRecoilState(editAboutModal);
  const [file, setFile] = useState({})
  const [editor, setEditor] = useRecoilState(aboutEditor);
  const [editorDesc, setEditorDesc] = useRecoilState(aboutEditorDesc)
  const [form] = Form.useForm()
  form.setFieldsValue({ position: value.position, content: value.content, id: value.id, image_url: value.image_url })

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('content', getHtml(editorDesc))
    // fd.append('title', val.title)
    // fd.append('content', val.content)
    fd.append('about_image', file);
    fd.append('id', val.id);
    fd.append('image_url', val.image_url);
    const res = await updateAbout({ data: fd, id: val.id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      setFile("")
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Update Feature</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item hidden name="id">
            <Input />
          </Form.Item>
          <Form.Item hidden name="image_url">
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="content" rules={[{ required: true }]}>
            {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 100,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item label="Postion" name="position">
            <Input type='number' />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <Button icon={<InboxOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}